module.exports = __webpack_public_path__ + "img/laptop-solid 1.bbaac551.svg";